import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../tools/AppConfig";

import Waiting from './../modules/waiting';
import Invoice from './invoice';
import Product from './product';
import InvoicePartner from './invoice_partner';
import ProductPartner from './product_partner';
import paymobLogo from './../../statics/img/paymobBlueLogo.svg';
class checkout extends Component {
  constructor(props){
    super(props);
    this.state = {
        dataLoaded: false,
        //acq_partner
        acq_partner: false,
        styleData: {},

    };
    this.loadStyleData = this.loadStyleData.bind(this);
  }
  loadStyleData(){
    let styleUrl = appConfig.getServerUrl() + '/api/auth/acq_partners/style?url=' + window.location.hostname ;
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.get(
        styleUrl,
        config
    )
    .then((respond)=>{
        this.setState({styleData: respond.data, acq_partner: true, dataLoaded: true})
    })
    .catch((err)=>{
      this.setState({acq_partner: false, dataLoaded: true})
    });
  }
  componentDidMount(){
    this.loadStyleData()
  }
  render() {
    var search = window.location.search.substring(1);
    let ref_page = search.substr(4, 1);
    let ref_token = search.substr(6);
    const domain_name = window.location.hostname;
    // if (domain_name === 'checkout.jawwalpay.ps' || domain_name === "stg.jawwalpay.ps") {
    if (this.state.dataLoaded && this.state.acq_partner) {
      return (
        <div className="App">
          {ref_page === "i"?
            <InvoicePartner styleData={this.state.styleData} token={ref_token} />
          :
            null
          }
          {ref_page === "p"?
            <ProductPartner styleData={this.state.styleData} token={ref_token} />
          :
            null
          }
        </div>
      );
    }else if (this.state.dataLoaded && !this.state.acq_partner){
      return (
        <div className="App newStandaloneLayout">
          {ref_page === "i"?
            <Invoice token={ref_token} />
          :
            null
          }
          {ref_page === "p"?
            <Product token={ref_token} />
          :
            null
          }
          <div className="footerNew">
          <img alt="Brand" src={paymobLogo} width="180" />
            <p>All rights reserved. Paymob 2020</p>
          </div>
        </div>
      );
    }else{
      return ( <Waiting height='100vh' /> )
    }
  }
}

export default checkout;
